"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

require("./AccessibilitySettings.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AccessibilitySettings = /*#__PURE__*/function () {
  function AccessibilitySettings() {
    _classCallCheck(this, AccessibilitySettings);
  }

  _createClass(AccessibilitySettings, null, [{
    key: "setAccessibilityFont",
    value: function setAccessibilityFont() {
      document.body.classList.remove('a11y-font-times-new-roman', 'a11y-font-arial', 'a11y-font-computer-default', 'a11y-font-open-dyslexic');
      var cookies = new _universalCookie.default();
      var cookie = cookies.get('icareCookieA11y');

      if (cookie) {
        var fontFamily = '';

        switch (cookie.changeFont) {
          case 'times-new-roman':
            fontFamily = 'a11y-font-times-new-roman';
            break;

          case 'arial':
            fontFamily = 'a11y-font-arial';
            break;

          case 'computer-default':
            fontFamily = 'a11y-font-computer-default';
            break;

          case 'open-dyslexic':
            fontFamily = 'a11y-font-open-dyslexic';
            break;

          default:
            return;
        }

        document.body.classList.add(fontFamily);
      }
    }
  }, {
    key: "setAccessibilityContrast",
    value: function setAccessibilityContrast() {
      document.body.classList.remove('high-contrast-mode', 'night-mode');
      var cookies = new _universalCookie.default();
      var cookie = cookies.get('icareCookieA11y');

      if (cookie) {
        switch (cookie.highContrast) {
          case 'turn-on':
            document.body.classList.add('high-contrast-mode');
            break;

          case 'night-mode':
            document.body.classList.add('night-mode');
            break;

          default:
            return;
        }
      }
    }
  }]);

  return AccessibilitySettings;
}();

exports.default = AccessibilitySettings;
//# sourceMappingURL=AccessibilitySettings.js.map